import React from 'react'
import './index.less'

/**
 * @param borderRadius 圆角大小
 * @param color 字体颜色
 * @param bgColor 背景颜色
 */

class Msg extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    isShow: false,
    time: 3,
    canRun: true,
    desc: ""
  }

  async componentWillMount() {

  }

  // 初始化/接口请求初始化
  RunOnStart = async () => {

  }

  componentDidMount() {

  }

  componentWillReceiveProps(e) {
  }

  /**
   * 
   * @param {*} msg 消息内容
   * @param {*} callback 结束回调
   * @returns 
   */
  show = (msg, callback) => {
    if (!this.state.canRun) {
      return false
    }
    this.setState({
      desc: msg,
      isShow: true,
      canRun: false
    })
    setTimeout(() => {
      callback && callback()
      this.setState({
        isShow: false,
        canRun: true
      })
    }, (this.state.time * 1000));
  }

  render() {
    let { borderRadius, color, bgColor } = this.props
    return (
      <div className='message-main-wrap' style={{ pointerEvents: `${this.state.isShow ? "" : "none"}` }}>
        <div
          style={{
            animationDuration: `${this.state.time}s`,
            borderRadius: `${borderRadius}`,
            color: `${color}`,
            backgroundColor: `${bgColor}`
          }}
          className={`message-box ${this.state.isShow ? "active" : "inactive"}`}>
          <span className='msg-content'>
            {/* 内容 */}
            {this.state.desc}
          </span>
        </div>
      </div>
    )
  }
}

export default Msg


// WEBPACK FOOTER //
// src/component/Message/index.js